import React from 'react';
import MatchPairsQuestionReport from './MatchPairsQuestionReport';
import DummyQuestionReport from './DummyQuestionReport';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IQuestionElements} from '../../../../incase-domain/elements/question';
import {ISlide} from '../../../../incase-domain/slide';
import {Font} from '../../../../incase-domain/presentationTheme';
import QuestionLayout from '../common/QuestionLayout';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import DummyLikertScaleReport from './DummyLikertScaleReport';
import {IElementQuestionMatchPair} from '../../../../incase-domain/elements/question/questionMatchPair';
import {IElementSequenceQuestion} from '../../../../incase-domain/elements/question/questionSequence';
import DummySequenceQuestionReport from './DummySequenceQuestionReport';

interface IRenderQuestionReportProps {
    question: IQuestionElements;
    slide: ISlide | undefined;
    fontFamily?: Font;
    device?: DeviceType;
}

function RenderQuestionReport({device, fontFamily, question, slide}: IRenderQuestionReportProps): JSX.Element {
    const renderReport = (): JSX.Element => {
        switch (question?.type) {
            case ELEMENT.MATCH_PAIR_QUESTION:
                return <MatchPairsQuestionReport question={question as IElementQuestionMatchPair} device={device} />;
            case ELEMENT.LIKERT_SCALE:
                return <DummyLikertScaleReport question={question} />;
            case ELEMENT.SEQUENCE_QUESTION:
                return <DummySequenceQuestionReport question={question as IElementSequenceQuestion} />;
            default:
                return <DummyQuestionReport question={question} slide={slide} />;
        }
    };

    if (!question) {
        return <></>;
    }

    return (
        <QuestionLayout element={question} device={device} hideCounter>
            <div
                style={{
                    fontFamily: fontFamily?.name,
                    fontSize: `${question?.fontSize || 'initial'}em`,
                }}
                className={`c-questionReport ${device === DeviceType.MOBILE ? 'c-questionReport--mobile' : ''}`}
            >
                {renderReport()}
            </div>
        </QuestionLayout>
    );
}

export default RenderQuestionReport;
